<div class="pdf-view-content pdf-only">
    <div class="pdf-view-header">
        <div class="pdf-view-title-section">
            <div>
                <h2 class="pdf-view-title">Print Job Sheet</h2>
                <p class="pdf-view-subtitle">
                    Review and print the job sheet for today
                </p>
            </div>
        </div>
        <button class="icon-btn" [pTooltip]="translate?.general.buttons.close.singular" (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="pdf-view-header cta">
            <div class="pdf-view-actions">
               <button pbutton [ngClass]="{'p-disabled': !pdfBlobUrl}"
                [disabled]="!pdfBlobUrl" 
                class="custella-btn-white"
                (click)="openEmailModal()">
                <i class="fa-regular fa-envelope"></i>&nbsp;Email
                </button>
               <p-button 
                    class="print-job-sheet__download-btn"
                    styleClass="h-32" 
                    icon="fa-regular fa-download" 
                    [pTooltip]="translate?.general.buttons.download.singular" 
                    tooltipPosition="top"
                    [disabled]="!pdfBlobUrl"
                    (onClick)="downloadPdf()">
                    </p-button> 
                 <p-multiSelect class="w-200px" [placeholder]="'Select a Technician'" 
                        [options]="users" 
                        optionLabel="name" 
                        optionValue="id" 
                        name="members" 
                        id="picklist_TeamMemberUserField"
                        [(ngModel)]="technicianIds" 
                        ></p-multiSelect>

                <p-button class="print-job-sheet__apply-btn" [label]="translate?.general.buttons.apply.singular" styleClass="h-32" [disabled]="isTechnicianIdsEmpty()" (click)="savePrintData()"></p-button>
            </div>
    </div>
    <div class="pdf-view-left">
        <div class="pdf-preview-container-only">

            <!-- ✅ PDF with parameters to hide sidebar and zoom in -->
            <iframe
            *ngIf="pdfBlobUrl"
            [src]="pdfBlobUrl + '#toolbar=1&navpanes=0&scrollbar=1&zoom=100' | safe: 'resourceUrl'"
            class="pdf-iframe"
            type="application/pdf">
            </iframe>

            <div class="pdf-placeholder" *ngIf="!pdfBlobUrl">
            <i class="fa-regular fa-file-pdf fa-3x color-muted"></i>
            <p class="color-muted mt-2">
                Select technicians and click apply to preview the job sheet
            </p>
            </div>

        </div>
</div>
</div>